var Curriculog = Curriculog || {};

Curriculog.User = (function ($, _, Backbone, User) {

	User = Backbone.Model.extend({
		defaults: function() {
			return {
				id: 0,
				first_name: '',
				last_name: '',
				email: '',
				status: '',
				permissions: {
					admin: 0,
					permissions_import_export: 0,
					permissions_originate_proposals: 0,
					transparency_accounts_view: 0,
					transparency_agendas_view: 0,
					transparency_dashboard_view: 0
				},
				signatureType: ''
			};
		}
	});

	return User;

})($, _, Backbone, Curriculog.User || {});
